import HttpRequest from '@/util/HttpRequest'

export default {

  /**
   * 위험평가 항목 제안 (유해위험요인 설명 목록 생성)
   * @params {사업장명, 공종명, 작업내용, 소속명, 부서명}
   */
  async GET_RISK_SUBTASKS({commit}, params) {
    const option = {
      사업장명: params.사업장명, // 필수
      공종명: params.공종명 || '',
      작업내용: params.작업내용, // 필수
      소속명: params.소속명 || '',
      부서명: params.부서명 || ''
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/risk-subtasks', { params: option })
        .then(response => {
          commit('SET_RISK_SUBTASKS', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 재난 유형 정의
   * @params {세부작업명}
   */
  async DEFINE_RISK_TYPE({commit}, params) {
    const option = {
      세부작업명: params.세부작업명, // 필수
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/define-risk-type', { params: option })
        .then(response => {
          commit('SET_RISK_TYPE', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 현재 안전보건조치 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태}
   */
  async GET_CURRENT_SAFETY_MEASURES({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명 || '',
      재해형태: params.재해형태 || ''
    }

    // 최소 1개 이상의 파라미터 확인
    const hasParams = Object.values(option).some(value => value !== '')
    if (!hasParams) {
      return Promise.reject(new Error('평가구분, 유해위험요인, 설명, 재해형태 중 최소 1개 이상의 정보를 입력해주세요'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/current-safety-measures', { params: option })
        .then(response => {
          commit('SET_CURRENT_SAFETY_MEASURES', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 현재 위험도 점수 제안 (가능성, 중대성, 위험성)
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치}
   */
  async MEASURE_CURRENT_RISK_POINT({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || ''
    }

    if (!option.설명) {
      return Promise.reject(new Error('설명은 필수 항목입니다'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/measure-current-risk-point', { params: option })
        .then(response => {
          commit('SET_CURRENT_RISK_POINT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 위험감소대책 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치, 가능성, 중대성}
   */
  async GET_RISK_REDUCTIONS({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || '',
      가능성: params.가능성 || '',
      중대성: params.중대성 || ''
    }

    if (!option.설명) {
      return Promise.reject(new Error('설명은 필수 항목입니다'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/risk-reductions', { params: option })
        .then(response => {
          commit('SET_RISK_REDUCTIONS', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 개선후 위험도 점수 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치, 가능성, 중대성, 위험감소대책}
   */
  async MEASURE_AFTER_RISK_POINT({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || '',
      가능성: params.가능성, // 필수
      중대성: params.중대성, // 필수
      위험감소대책: params.위험감소대책 // 필수
    }

    // 필수 파라미터 검증
    const requiredFields = ['설명', '가능성', '중대성', '위험감소대책']
    for (const field of requiredFields) {
      if (!option[field]) {
        return Promise.reject(new Error(`${field}은(는) 필수 항목입니다`))
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/measure-after-risk-point', { params: option })
        .then(response => {
          commit('SET_AFTER_RISK_POINT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 이미지 기반 위험성평가 분석
   * @params {image, content}
   * image: 분석할 이미지 파일 (File 객체)
   * content: 위험성평가 관련 정보 객체 (선택사항)
   *   - 예시: {사업장: "달지배수펌프장", 작업내용: "슬러지 제거 작업", 부서명: "시설관리팀"}
   */
  async ANALYZE_IMAGE_RISK({commit}, params) {
    // 필수 파라미터 검증
    if (!params.image) {
      return Promise.reject(new Error('이미지 파일은 필수 항목입니다'))
    }

    // FormData 생성
    const formData = new FormData()
    formData.append('image', params.image)

    // 컨텍스트 정보가 있으면 JSON 문자열로 추가
    if (params.content && typeof params.content === 'object') {
      // 빈 값이 아닌 항목만 필터링
      const filteredContent = Object.fromEntries(
        Object.entries(params.content).filter(([key, value]) => value && String(value).trim() !== ''
        )
      )

      if (Object.keys(filteredContent).length > 0) {
        formData.append('content', JSON.stringify(filteredContent))
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/image-analysis', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          commit('SET_IMAGE_RISK_ANALYSIS', response)
          resolve(response)
        })
        .catch(err => {
          // 에러 처리 및 사용자 친화적 메시지 제공
          let errorMessage = '이미지 분석 중 오류가 발생했습니다'

          if (err.response) {
            const { status, data } = err.response

            switch (status) {
            case 400:
              errorMessage = '잘못된 요청입니다. 이미지 파일을 확인해주세요'
              break
            case 406:
              errorMessage = 'AI 분석 서비스 설정에 문제가 있습니다. 관리자에게 문의하세요'
              break
            case 500:
              errorMessage = '서버 내부 오류가 발생했습니다. 잠시 후 다시 시도해주세요'
              break
            default:
              errorMessage = (data && data.error) || errorMessage
            }
          } else if (err.request) {
            errorMessage = '네트워크 연결을 확인해주세요'
          }

          reject(new Error(errorMessage))
        })
    })
  },

  /**
   * AI 음성/텍스트 통역
   * @params {audio, text, inputLang, outputLang, voice, enableAudio}
   * audio: 음성 파일 (File 객체) - 선택사항
   * text: 직접 입력 텍스트 (String) - 선택사항
   * inputLang: 입력 언어 코드 (String) - 기본값: 'ko'
   * outputLang: 출력 언어 코드 (String) - 기본값: 'en'
   * voice: TTS 음성 모델 (String) - 기본값: 'nova'
   * enableAudio: TTS 음성 생성 여부 (Boolean) - 기본값: true
   */
  async VOICE_TRANSLATE({commit}, params) {
    const { audio, text, inputLang = 'ko', outputLang = 'en', voice = 'nova', enableAudio = true } = params

    // 입력 검증
    if (!audio && !text) {
      return Promise.reject(new Error('audio 파일 또는 text 파라미터 중 하나는 필수입니다'))
    }

    if (audio && text) {
      return Promise.reject(new Error('audio 파일과 text 파라미터는 동시에 사용할 수 없습니다'))
    }

    // 음성 파일 검증
    if (audio) {
      // 파일 크기 검증 (25MB)
      if (audio.size > 25 * 1024 * 1024) {
        return Promise.reject(new Error('음성 파일 크기는 25MB를 초과할 수 없습니다'))
      }

      // 지원 형식 검증
      const supportedFormats = ['mp3', 'mp4', 'mpeg', 'mpga', 'm4a', 'wav', 'webm']
      const fileExtension = audio.name.split('.').pop().toLowerCase()
      if (!supportedFormats.includes(fileExtension)) {
        return Promise.reject(new Error(`지원되지 않는 파일 형식입니다. 지원 형식: ${supportedFormats.join(', ')}`))
      }
    }

    // 텍스트 검증
    if (text && typeof text === 'string' && text.trim() === '') {
      return Promise.reject(new Error('빈 텍스트는 사용할 수 없습니다'))
    }

    // FormData 생성
    const formData = new FormData()

    // 음성 파일 또는 텍스트 추가
    if (audio) {
      formData.append('audio', audio)
    } else {
      formData.append('text', text.trim())
    }

    // 공통 파라미터 추가
    formData.append('inputLang', inputLang)
    formData.append('outputLang', outputLang)
    formData.append('voice', voice)
    formData.append('enableAudio', enableAudio)

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/voice-translate', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          if (response.success) {
            commit('SET_VOICE_TRANSLATE_RESULT', response.data)
            resolve(response.data)
          } else {
            reject(new Error(response.error || '통역에 실패했습니다'))
          }
        })
        .catch(err => {
          // 에러 처리 및 사용자 친화적 메시지 제공
          let errorMessage = '통역 중 오류가 발생했습니다'

          if (err.response) {
            const { status, data } = err.response

            switch (status) {
            case 400:
              errorMessage = (data && data.error) || '잘못된 요청입니다. 입력 데이터를 확인해주세요'
              break
            case 406:
              errorMessage = 'AI 통역 서비스 설정에 문제가 있습니다. 관리자에게 문의하세요'
              break
            case 413:
              errorMessage = '파일 크기가 너무 큽니다. 25MB 이하의 파일을 사용해주세요'
              break
            case 415:
              errorMessage = '지원되지 않는 파일 형식입니다'
              break
            case 429:
              errorMessage = '요청이 너무 많습니다. 잠시 후 다시 시도해주세요'
              break
            case 500:
              errorMessage = '서버 내부 오류가 발생했습니다. 잠시 후 다시 시도해주세요'
              break
            default:
              errorMessage = (data && data.error) || errorMessage
            }
          } else if (err.request) {
            errorMessage = '네트워크 연결을 확인해주세요'
          } else if (err.message) {
            errorMessage = err.message
          }

          reject(new Error(errorMessage))
        })
    })
  },

  /**
   * TTS 음성 생성 (번역 없이 텍스트를 음성으로 변환)
   * @params {text, lang, voice}
   * text: 음성으로 변환할 텍스트 (String) - 필수
   * lang: 언어 코드 (String) - 기본값: 'ko'
   * voice: TTS 음성 모델 (String) - 기본값: 'nova'
   */
  async TEXT_TO_SPEECH(context, params) {
    const { text, lang = 'ko', voice = 'nova' } = params

    // 입력 검증
    if (!text || (typeof text === 'string' && text.trim() === '')) {
      return Promise.reject(new Error('text 파라미터는 필수입니다'))
    }

    // JSON 요청 생성
    const requestData = {
      text: text.trim(),
      lang,
      voice
    }

    return new Promise((resolve, reject) => {
      // responseType을 제거하고 일반 JSON 응답으로 처리
      HttpRequest.post('/api/v1/miras/tts', requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('TTS API 응답:', response)

          // 다양한 응답 형식 처리
          if (response.success && response.data && response.data.audioUrl) {
            // 표준 형식: {success: true, data: {audioUrl: "..."}}
            console.log('TTS 표준 응답 형식, audioUrl:', response.data.audioUrl)
            resolve(response.data)
          } else if (response.data && response.data.audioUrl) {
            // data 안에 audioUrl: {data: {audioUrl: "..."}}
            console.log('TTS data.audioUrl 형식, audioUrl:', response.data.audioUrl)
            resolve(response.data)
          } else if (response.audioUrl) {
            // audioUrl이 직접 응답에 포함: {audioUrl: "..."}
            console.log('TTS 직접 audioUrl 형식, audioUrl:', response.audioUrl)
            resolve(response)
          } else if (response.success && response.data) {
            // success는 있지만 구조가 다른 경우
            console.log('TTS success 형식, data:', response.data)
            resolve(response.data)
          } else if (typeof response === 'string') {
            // URL 문자열만 반환
            console.log('TTS URL 문자열 형식:', response)
            resolve({ audioUrl: response })
          } else {
            // 응답 구조를 파악할 수 없는 경우
            console.error('TTS API 응답 구조를 파악할 수 없습니다:', response)
            console.error('response keys:', Object.keys(response || {}))
            reject(new Error('TTS 생성에 실패했습니다'))
          }
        })
        .catch(err => {
          // 에러 처리 및 사용자 친화적 메시지 제공
          let errorMessage = 'TTS 생성 중 오류가 발생했습니다'

          if (err.response) {
            const { status, data } = err.response

            switch (status) {
            case 400:
              errorMessage = (data && data.error) || '잘못된 요청입니다. 입력 데이터를 확인해주세요'
              break
            case 406:
              errorMessage = 'TTS 서비스 설정에 문제가 있습니다. 관리자에게 문의하세요'
              break
            case 429:
              errorMessage = '요청이 너무 많습니다. 잠시 후 다시 시도해주세요'
              break
            case 500:
              errorMessage = '서버 내부 오류가 발생했습니다. 잠시 후 다시 시도해주세요'
              break
            default:
              errorMessage = (data && data.error) || errorMessage
            }
          } else if (err.request) {
            errorMessage = '네트워크 연결을 확인해주세요'
          } else if (err.message) {
            errorMessage = err.message
          }

          reject(new Error(errorMessage))
        })
    })
  },

  // ── 실시간 음성 통역 (AI 통역 PM) ──────────────────────────────
  // 모든 호출은 OctoberCMS 경유 — jwt.auth 미들웨어가 사용자 식별
  // (user_id / username 은 클라이언트가 보내지 않음 — JWT에서 추출)

  /**
   * WebSocket 토큰 발급 + 세션 시작
   * @params {source_language, target_language}
   */
  async VOICE_TOKEN(_ctx, params) {
    const body = {
      source_language: params.source_language,
      target_language: params.target_language,
    }
    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/voice/token', body)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 메시지 저장 (각 turn_complete 시점 호출)
   */
  async VOICE_HISTORY(_ctx, params) {
    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/voice/history', params)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 세션 종료
   * @params {sessionId}
   */
  async VOICE_SESSION_END(_ctx, params) {
    const sessionId = params.sessionId
    return new Promise((resolve, reject) => {
      HttpRequest.post(`/api/v1/miras/voice/session/${sessionId}/end`)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 녹음 세션 목록 (구 voice/sessions — 호환 유지)
   */
  async VOICE_SESSIONS_LIST(_ctx, params) {
    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/voice/sessions', { params })
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 세션 상세
   * @params {sessionId}
   */
  async VOICE_SESSION_DETAIL(_ctx, params) {
    const sessionId = params.sessionId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/miras/voice/sessions/${sessionId}`)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 세션 삭제
   * @params {sessionId}
   */
  async VOICE_SESSION_DELETE(_ctx, params) {
    const sessionId = params.sessionId
    return new Promise((resolve, reject) => {
      HttpRequest.delete(`/api/v1/miras/voice/sessions/${sessionId}`)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 녹음 히스토리 목록
   * @params {page, limit}
   */
  async VOICE_RECORDINGS_LIST(_ctx, params) {
    const option = {
      params: {
        page:  params.page  ? params.page  : 1,
        limit: params.limit ? params.limit : 20,
      },
    }
    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/voice/recordings', option)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  /**
   * 녹음 히스토리 상세
   * @params {recordingId}
   */
  async VOICE_RECORDING_DETAIL(_ctx, params) {
    const recordingId = params.recordingId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/miras/voice/recordings/${recordingId}`)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  // ── AI 음성 작성 (게시판 폼 자동 채우기) ────────────────────────
  // 모든 호출은 OctoberCMS(jwt.auth) 경유 → miras-ai FastAPI

  /**
   * 녹음한 음성을 텍스트로 변환한다 (Whisper, 번역 없음)
   * @params {audio: Blob|File, language}
   * @returns {Promise<{transcribed_text, detected_language, audio_duration_seconds}>}
   */
  async VOICE_TRANSCRIBE(_ctx, params) {
    if (!params || !params.audio) {
      return Promise.reject(new Error('음성 데이터가 없습니다'))
    }

    const formData = new FormData()
    // 서버(FastAPI)는 확장자로 오디오 형식을 판별하므로 파일명을 함께 넘긴다.
    formData.append('audio_file', params.audio, params.filename || 'record.webm')
    formData.append('language', params.language || 'ko')

    // FormData 를 넘기면 axios 가 multipart 경계(boundary)를 알아서 붙인다.
    // 세 번째 인자는 notWarn — 실패 알럿은 팝업에서 직접 띄우므로 공통 알럿은 끈다.
    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/voice/transcribe', formData, true)
        .then(response => {
          if (response && response.success) resolve(response)
          else reject(new Error((response && response.error) || '음성 인식에 실패했습니다'))
        })
        .catch(err => reject(err))
    })
  },

  /**
   * 발화 내용을 분석해서 폼 데이터(의미 ID 기준)를 채운다
   * @params {boardId, schema, formState, transcript, locale, speaker}
   *   speaker: 작성자 정보. "점검자는 나야" 처럼 1인칭으로 말했을 때 이름을 채우는 데 쓴다.
   *            (이름/부서/직급은 서버가 JWT 기준으로 다시 채우므로 회사명만 실제로 반영된다)
   * @returns {Promise<{patch, next_questions, warnings}>}
   */
  async FORM_FILL_ANALYZE(_ctx, params) {
    const body = {
      board_id: params.boardId,
      schema: params.schema,
      form_state: params.formState || {},
      transcript: params.transcript,
      locale: params.locale || 'ko',
      speaker: params.speaker || {},
    }

    return new Promise((resolve, reject) => {
      // notWarn = true — 실패 안내는 팝업이 직접 처리한다.
      HttpRequest.post('/api/v1/miras/form-fill/analyze', body, true)
        .then(response => {
          if (response && response.success) resolve(response.data)
          else reject(new Error((response && response.error) || '음성 분석에 실패했습니다'))
        })
        .catch(err => reject(err))
    })
  },
}
